import React from "react";

import { withStyles } from '@material-ui/styles';
import { withRouter } from 'react-router-dom';
import withCurrentUser from '../../../hocs/with_current_user.js.jsx';
import withShowToast from '../../../hocs/with_show_toast.js.jsx';
import { compose } from 'redux';

import I18n from "../../../base/i18n.js.jsx";

import FormFields from "../../../base/form/form_fields.js.jsx";
import Button from "../../../base/buttons/button.js.jsx";
import BackButton from "../../../base/buttons/back_button.js";

import BaseSessionPage from "./components/base_session_page.js.jsx";

import { SignInInfoModel } from "../../../models/session/sign_in_info_model.js.jsx";

import SendResetPasswordUseCase from "../../../use_cases/passwords/send_reset_password_use_case.js.jsx";

import Routes from "../../routes.js";

const styles = theme => ({
  button: {
    margin: "16px 0px",
    width: "100%",
    minWidth: "375px",
    ['@media (max-width: 768px)']:{
      margin: "40px 0 45px"
    }
  },
  text: {
    display: "block",
    fontSize: "24px",
    fontWeight: theme.typography.fontWeightLight,
    marginBottom: "70px"
  },
  title: {
    fontSize: "20px",
    padding: "0",
    marginBottom: "32px",
    ['@media (max-width: 768px)']: {
      fontSize: "18px",
      lineHeight: "16px",
      marginBottom: "34px"
    }
  },
  signInContainer: {
    display: "flex",
    justifyContent: "flex-end"
  }
});


class ForgotPasswordPage extends React.Component {

  constructor(props) {
    super(props);

    this.signInInfo = {
    }

    this.state = {
      ...this.state,
      formFields: this.fieldsForStep()
    };

    this.onItemChange = this.onItemChange.bind(this);

    this.onSubmit = this.onSubmit.bind(this);

    this.onComeBack = this.onComeBack.bind(this);
  }

  componentDidUpdate(prevProps, prevState) {
    const { currentUser: prevUser } = prevProps
    const { currentUser } = this.props;

    if(!prevUser && currentUser) {
      this.onComeBack();
    }
  }

  onItemChange(changedItem) {
    this.signInInfo = changedItem;
  }

  onSubmit(event) {
    event.preventDefault();

    if(!this.allowToSubmit()) {
      return;
    }
    this.setState({
      submit: true,
      errorData: undefined
    });

    SendResetPasswordUseCase.execute(this.signInInfo)
    .then((result) => {
      const { history } = this.props;
      this.props.loadUser();
      history.replace(Routes.index());
      this.props.showSuccessMessage(I18n.t("web.page.forgot_password.password_change_requested"));
    })
    .catch((result) => {
      const { errorData } = result;

      this.setState({
        submit: false,
        errorData: errorData
      });
      this.props.showServerErrorIfNeed(result);
    });
    return;
  }

  onComeBack() {
    const { history } = this.props;
    if(history.length > 2) {
      history.goBack()
    }
    else {
      history.replace(Routes.index())
    }
  }

  fieldsForStep() {
    let fields = SignInInfoModel.formFields();
    let whiteList = ["email"];
    return fields.filter((field) => whiteList.includes(field.name));
  }

  render() {
    const { classes } = this.props;
    return <BaseSessionPage>
      <div className = { classes.title }>{ I18n.t("web.page.forgot_password.title")}</div>
      <form onSubmit = { this.onSubmit } >
        { this.form() }
      </form>
    </BaseSessionPage>
  }

  form() {
    const { classes } = this.props;

    const { formFields, submit, errorData } = this.state;

    const { signInInfo } = this;

    return <React.Fragment>
      <FormFields formFields = { formFields }
                  item = { signInInfo }
                  errorData = { errorData }
                  onItemChange = { this.onItemChange }
                  defaultWeight = { 12 } />
      <Button className = { classes.button }
              type = { "submit" }
              disabled = { submit } >
        { I18n.t("action.send") }
      </Button>
    </React.Fragment>
  }

  allowToSubmit() {
    return true;
  }
}

export default compose(withRouter, withShowToast, withCurrentUser, withStyles(styles))(ForgotPasswordPage)
